import CustomTable from '@myComponents/CustomTable';
import { ListScheduledNotifications } from '../../../graphql/Query/notifications';
import { DeleteScheduledNotification } from '../../../graphql/Mutation/notifications';
import { useMutation, useQuery } from '@apollo/client';
import { columns } from './columns';
import { useState } from 'react';
import Sidebar from './Sidebar';
import { handleConfirmCancel, handleError } from '@components/toast';

const variables = {
  search: {
    membership: 'EMPTY',
    q: '',
    perPage: 10,
    page: 1
  }
};

const defaultValues = {
  title: '',
  membership: ['FREE'],
  message: '',
  active: true,
  date:'08:00',
  days:0,
  notificationType:'MEMBERSHIP'
};

const ScheduledNotifications = () => {
  const { data, refetch, loading } = useQuery(ListScheduledNotifications, {
    variables
  });
  const [valuesForm, setValuesForm] = useState({});
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [handleDisable] = useMutation(DeleteScheduledNotification);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
    refetch();
  };

  const handleDelete = async (id) => {
    handleConfirmCancel('delete', false, async () => {
      try {
        await handleDisable({ variables: { id } });
        refetch();
      } catch (e) {
        handleError(e);
        throw e;
      }
    });
  };

  const handleUpdate = ({ e, row }) => {
    e.preventDefault();
    setValuesForm({
      ...row,     
    });
    toggleSidebar();
  };

  return (
    <CustomTable
      loading={loading}
      store={data?.listScheduledNotifications?.docs || []}
      data={{ ...data?.listScheduledNotifications, docs: undefined }}
      refetch={refetch}
      headerOptions={{
        type: 'add',
        name: 'Crear Notification',
        handle: () => {
          setValuesForm(defaultValues);
          toggleSidebar();
        }
      }}
      filterOptions={{
        types: [
          {
            id: 'incomes_membership',
            name: 'membership',
            options: 'scheduledMembershipOptions',
            type: 'select'
          }
        ]
      }}
      variables={variables}
      columns={columns({ handleDelete, handleUpdate })}
      sidebar={
        <Sidebar
          open={sidebarOpen}
          toggleSidebar={toggleSidebar}
          defaultValues={valuesForm}
        />
      }
    />
  );
};

export default ScheduledNotifications;
